export default __webpack_public_path__ + "static/media/calendar-icon-bw.089add72.svg";